// Country list with international dial codes for the registration form.
export const COUNTRIES = [
    { name: "United States", code: "US", dial: "+1" },
    { name: "Canada", code: "CA", dial: "+1" },
    { name: "United Kingdom", code: "GB", dial: "+44" },
    { name: "Ireland", code: "IE", dial: "+353" },
    { name: "Australia", code: "AU", dial: "+61" },
    { name: "New Zealand", code: "NZ", dial: "+64" },
    { name: "India", code: "IN", dial: "+91" },
    { name: "Germany", code: "DE", dial: "+49" },
    { name: "France", code: "FR", dial: "+33" },
    { name: "Spain", code: "ES", dial: "+34" },
    { name: "Italy", code: "IT", dial: "+39" },
    { name: "Netherlands", code: "NL", dial: "+31" },
    { name: "Belgium", code: "BE", dial: "+32" },
    { name: "Switzerland", code: "CH", dial: "+41" },
    { name: "Sweden", code: "SE", dial: "+46" },
    { name: "Norway", code: "NO", dial: "+47" },
    { name: "Denmark", code: "DK", dial: "+45" },
    { name: "Portugal", code: "PT", dial: "+351" },
    { name: "Austria", code: "AT", dial: "+43" },
    { name: "Poland", code: "PL", dial: "+48" },
    { name: "United Arab Emirates", code: "AE", dial: "+971" },
    { name: "Saudi Arabia", code: "SA", dial: "+966" },
    { name: "Singapore", code: "SG", dial: "+65" },
    { name: "Hong Kong", code: "HK", dial: "+852" },
    { name: "Japan", code: "JP", dial: "+81" },
    { name: "South Korea", code: "KR", dial: "+82" },
    { name: "China", code: "CN", dial: "+86" },
    { name: "Brazil", code: "BR", dial: "+55" },
    { name: "Mexico", code: "MX", dial: "+52" },
    { name: "Argentina", code: "AR", dial: "+54" },
    { name: "South Africa", code: "ZA", dial: "+27" },
    { name: "Nigeria", code: "NG", dial: "+234" },
    { name: "Kenya", code: "KE", dial: "+254" },
    { name: "Egypt", code: "EG", dial: "+20" },
];
